<template>
    <div class="cf-wrapper">
        <div class="cf-container"  v-if="form.length > 0">
            <draggable 
                tag="div" 
                :list="form" 
                class="form-list-group" 
                handle=".cf-control-handle" 
                v-if="form && form.length > 0" 
                @start="isDragging = true" 
                @end="isDragging = false"
                :animation="200"
                group="inputs"
                :disabled="false"
                ghostClass="ghost"> 
                <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
                    <div class="cf-input" v-for="(input, index) in form" :key="index">
                        <template v-if="input.render">
                            <div class="cf-control-handle">
                                <i class="fa fa-align-justify"></i>
                            </div>
                            <div class="cf-input-control">
                                <CustomInputs :input="input"></CustomInputs>
                            </div>
                            <div class="cf-input-labels" v-if="labelAssignment">
                                <label class="badge" @click="assignInput(input, 'name')"  :class="[{ 'selected' : input.name === 'name' },  { 'disabled' : input.fieldtype !== 'text' }]">N</label>
                                <label class="badge" @click="assignInput(input, 'email')" :class="[{ 'selected' : input.name === 'email' }, { 'disabled' : input.fieldtype !== 'email'}]">E</label>
                                <label class="badge" @click="assignInput(input, 'phone')" :class="[{ 'selected' : input.name === 'phone' }, { 'disabled' : input.fieldtype !== 'text' }]">P</label>
                                <!-- <label class="badge" @click="resetInput(input)" :class="{ 'disabled' : input.fieldtype !== 'text' }"><i class="fa fa-undo"></i></label> -->
                            </div>
                            <div class="cf-input-options">
                                <div>
                                    <n-button type="warning" size="sm" round icon simple @click.native="editInput(input)">
                                        <i class="fa fa-pencil"></i>
                                    </n-button>
                                    <n-button type="primary" size="sm" round icon simple @click.native="copyInput(input)">
                                        <i class="now-ui-icons files_single-copy-04"></i>
                                    </n-button>
                                    <n-button type="danger" size="sm" round icon simple @click.native="deleteInput(input)">
                                        <i class="now-ui-icons ui-1_simple-remove"></i>
                                    </n-button>
                                </div>
                            </div>
                        </template>
                    </div>
                </transition-group>
            </draggable>
        </div>
        <div class="cf-creator">
            <div class="row">
                <div class="col-sm-4">
                    <fg-input
                        type="text"
                        name="fieldtype"
                        label="Field Type"
                        v-validate="modelValidations.fieldtype"
                        :error="getError('fieldtype')"
                        v-model="model.fieldtype">
                        <el-select class="select-default" placeholder="Select Field Type" v-model="model.fieldtype" clearable filterable>
                            <el-option v-for="(option, index) in types" class="select-primary" :value="option" :label="option" :key="index">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="col-sm-4">
                    <fg-input
                        type="number"
                        name="price"
                        label="Price"
                        v-validate="modelValidations.price"
                        :error="getError('price')"
                        v-model="model.price">
                    </fg-input>
                </div>
                <div class="col-sm-4">
                    <fg-input
                        type="text"
                        required
                        name="required"
                        label="Required?"
                        v-validate="modelValidations.required"
                        :error="getError('required')"
                        v-model="model.required">
                        <n-switch v-model="model.required" on-text="True" off-text="False"></n-switch>
                    </fg-input>
                </div>
                <div class="col-sm-6">
                    <fg-input
                        type="text"
                        required
                        name="displayname"
                        label="Name"
                        v-validate="modelValidations.displayname"
                        :error="getError('displayname')"
                        v-model="model.displayname"
                        inputClasses="form-control-sm">
                    </fg-input>
                </div>
                <div class="col-sm-6">
                    <fg-input
                        type="text"
                        name="description"
                        label="Description"
                        v-validate="modelValidations.description"
                        :error="getError('description')"
                        v-model="model.description"
                        inputClasses="form-control-sm">
                    </fg-input>
                </div>
                <div class="col-sm-4">
                    <fg-input
                        type="text"
                        name="dependentOn"
                        label="Dependent On"
                        v-validate="modelValidations.dependentOn"
                        :error="getError('dependentOn')"
                        v-model="model.dependentOn">
                        <el-select class="select-default" placeholder="Select Field Type" v-model="model.dependentOn" clearable filterable>
                            <el-option v-for="(option, index) in form" class="select-primary" :value="option.name" :label="option.displayname" :key="index">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="col-sm-8">
                    <div v-if="needsOptions">
                        <label>Options</label>
                        <input type="text" placeholder="Add new tag" class="form-control input-new-tag" v-model="model.input" ref="saveTagInput" size="mini" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                        <el-tag :key="index" v-for="(val, index) in model.options" size="small" type="primary" :closable="true" :close-transition="false" @close="handleClose(val)">{{ (model.fieldtype == 'number') ? `${val}` : `${val.name} - ${val.price}` }}</el-tag>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center text-danger text-sm" v-if="errorMsg">{{ errorMsg }}</div>
                <div class="col-sm-6 text-left">
                    <n-button @click.native="saveForm()" type="success" round> <i class="now-ui-icons ui-1_check"></i> Save Custom Form</n-button>
                </div>
                <div class="col-sm-6 text-right">
                    <n-button @click.native="addToForm()" type="primary" round> <i class="now-ui-icons ui-1_simple-add"></i> Add to Form</n-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { FormGroupInput, Card, Button, Switch  } from 'src/components';
import { Select, Option, Tag } from 'element-ui';
import { isNull } from 'util';
import draggable from "vuedraggable";

import CustomInputs from './CustomInputs'

// https://gist.github.com/codeguy/6684588#gistcomment-2690429
function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaaaeeeeiiiioooouuuunc------";

    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, ""); // trim - from end of text

    return str;
}

export default {
    name: 'CustomForm',
    components: {
        draggable,
        CustomInputs,
        [Tag.name]: Tag,
        [Switch.name]: Switch,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        [FormGroupInput.name]: FormGroupInput,
    },
    props: {
        pool: {
            type: Boolean,
            default: false
        },
        login: {
            type: Boolean,
            default: false
        },
        forms: {
            type: Array,
            default: () => []
        },
        labelAssignment: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        form: {
            handler: function (inputs, oldInputs) {
                inputs.forEach((input) => {
                    if(input.dependentOn !== null){
                        let dependentField = this.form.find(el => el.name === input.dependentOn);
                        if(dependentField)
                            input.render = dependentField.value;
                    }
                })
            },
            deep: true
        },
        forms(){
            this.form = this.forms
        }
    },
    computed: {
        needsOptions(){
            let ret = false
            switch(this.model.fieldtype){
                case 'number':
                case 'radio':
                case 'switch':
                case 'checkbox':
                case 'select-single':
                case 'select-multiple': ret = true; break;
                default: ret = false
            }
            return ret;
        },
        types(){
            
            if(this.pool && this.login){
                return this.primitiveTypes.concat(['participant', 'student', 'teacher'])
            }
            else if(this.pool && !this.login){
                return this.primitiveTypes.concat(['participant'])
            }
            else{
                return this.primitiveTypes
            }

        }
    },
    mounted(){
        this.form = this.forms
    },
    data(){
        return {
            isDragging: false,
            errorMsg: '',
            primitiveTypes: [
                'text',
                'email',
                'number',
                'radio',
                'switch',
                'checkbox',
                'select-single',
                'select-multiple',
                'datepicker',
                'datetimepicker',
                'file',
            ],
            form: [],
            testform: [
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"text",
                    "required":true,
                    "name":"name",
                    "displayname":"Full Name",
                    "description": "hello world",
                    "price":0,
                    "options":[],
                    "value":"",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"email",
                    "required":true,
                    "name":"email",
                    "displayname":"Email Address",
                    "description":"Your active email address, this email address will be used for further communications.",
                    "price":null,
                    "options":[],
                    "value":"",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"radio",
                    "required":true,
                    "name":"batch-year",
                    "displayname":"Batch Year",
                    "description":"Select year of admission from 1999 to 2018.",
                    "price":null,
                    "options":[  
                        {  
                            "name":"1999",
                            "price":0
                        },
                        {  
                            "name":"2000",
                            "price":0
                        },
                    ],
                    "value":"2017:::0",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"checkbox",
                    "required":true,
                    "name":"batch-year",
                    "displayname":"Batch Year",
                    "description":"Select year of admission from 1999 to 2018.",
                    "price":null,
                    "options":[  
                        {  
                            "name":"1999",
                            "price":0
                        },
                        {  
                            "name":"2000",
                            "price":0
                        },
                    ],
                    "value":"2017:::0",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"select-multiple",
                    "required":true,
                    "name":"batch-year",
                    "displayname":"Batch Year",
                    "description":"Select year of admission from 1999 to 2018.",
                    "price":null,
                    "options":[  
                        {  
                            "name":"1999",
                            "price":0
                        },
                        {  
                            "name":"2000",
                            "price":0
                        },
                    ],
                    "value":"2017:::0",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"select-single",
                    "required":true,
                    "name":"batch-year",
                    "displayname":"Batch Year",
                    "description":"Select year of admission from 1999 to 2018.",
                    "price":null,
                    "options":[  
                        {  
                            "name":"1999",
                            "price":0
                        },
                        {  
                            "name":"2000",
                            "price":0
                        },
                    ],
                    "value":"2017:::0",
                    "factor":null
                },
                {  
                    "dependentOn":null,
                    "render":true,
                    "fieldtype":"switch",
                    "required":true,
                    "name":"accompanied-by",
                    "displayname":"I would be accompanied by someone ?",
                    "price":0,
                    "value":"false",
                    "factor":null,
                    "options":[  
                        {  
                        "name":"Yes",
                        "price":0
                        },
                        {  
                        "name":"No",
                        "price":0
                        }
                    ]
                },
                {  
                    "dependentOn":"accompanied-by",
                    "render":false,
                    "fieldtype":"number",
                    "required":false,
                    "name":"kids",
                    "displayname":"Number of kids ?",
                    "description":null,
                    "price":0,
                    "value":"0",
                    "factor":0,
                    "options":[  
                        {  
                            "name":"min",
                            "price":0
                        },
                        {  
                            "name":"max",
                            "price":10
                        }
                    ]
                }
            ],
            model: {
                fieldtype: null,
                dependentOn: null,
                render: true,
                required: false,
                name: null,
                displayname: null,
                description: null,
                price: 0,
                options: [],
                value: null,
                factor: null
            },
            modelValidations: {
                fieldtype:{ required: true },
                dependentOn:{ required: false },
                render:{ required: true },
                required:{ required: true },
                name:{ required: true },
                displayname:{ required: true },
                description:{ required: false },
                price:{ required: true },
                options:{ required: false },
                value:{ required: false },
                factor:{ required: false },
            },
            input: '',
            isEditing: false,
            inputIndex: null
        }
    },
    methods: {
        editInput(input){
            this.inputIndex = this.form.indexOf(input)
            this.model = Object.assign({}, input)
            this.deleteInput(input)
            this.isEditing = true
        },
        copyInput(input){
            this.isEditing = false
            this.model = Object.assign({}, input)
        },
        deleteInput(input){
            this.isEditing = false
            this.form.splice(this.form.indexOf(input), 1)
        },
        resetInput(input){
            input.name = string_to_slug(input.displayname)
        },
        assignInput(input, type){

            if((type == 'email' && input.fieldtype == 'email') || (input.fieldtype == 'text' && type != 'email')){
                // other input with same type as name
                let inp = this.form.find((item) => item.name == type)
                if(inp){
                    // cover the newly found input with slug from displayname
                    inp.name = (string_to_slug(inp.displayname) == type) ? `${string_to_slug(inp.displayname)}-1` : string_to_slug(inp.displayname)
                }

                // check for fieldtype match and then update the input with assigning type
                if(type == 'name' && input.fieldtype == 'text')
                    input.name = type
                else if(type == 'email' && input.fieldtype == 'email')
                    input.name = type
                else if(type == 'phone' && input.fieldtype == 'text')
                    input.name = type
            }
        },
        addToForm(){
            return this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // make name slug out of the display name
                    this.model.name = string_to_slug(this.model.displayname)

                    // validation checks
                    if(this.needsOptions && this.model.options.length < 2){
                        if(this.model.fieldtype == 'number' && this.model.options.length < 2){
                            this.errorMsg = `'${this.model.fieldtype}' form element requires atleast min and max options.`
                            return false
                        }
                        else if((this.model.fieldtype == 'switch' || this.model.fieldtype == 'radio' || this.model.fieldtype == 'checkbox') && this.model.options.length < 2){
                            this.errorMsg = `'${this.model.fieldtype}' form element requires atleast 2 options.`
                            return false
                        }
                        else if(this.model.options.length < 1){
                            this.errorMsg = `'${this.model.fieldtype}' form element requires atleast one option.`
                            return false
                        }
                    }

                    // check if the field is checkbox
                    if(this.model.fieldtype == 'checkbox'){
                        // this.model.factor = parseInt(this.model.price)
                        // this.model.price = this.model.factor * this.model.value
                        this.model.value = []
                    }

                    // check if the field is number
                    if(this.model.fieldtype == 'number'){
                        this.model.factor = parseInt(this.model.price)
                        this.model.price = this.model.factor * this.model.value
                    }

                    console.log('form-input', this.model);

                    // check if editing is in progress, if so do not push to form array
                    if(!this.isEditing){
                        let isDuplicate = this.form.some((input) => {
                            return input.name == this.model.name
                        })
                        if(isDuplicate){
                            this.errorMsg = `'${this.model.displayname}' form element already exists.`
                            return false
                        }
                        this.form.push(this.model)
                    }
                    else{
                        let count = this.form.filter(item => item.name == this.model.name).length
                        if(count >= 1){
                            this.errorMsg = `'${this.model.displayname}' form element already exists.`
                            return false
                        }
                        this.form.splice(this.inputIndex, 0, this.model);
                    }

                    this.model = {
                        fieldtype: null,
                        dependentOn: null,
                        render: true,
                        required: false,
                        name: null,
                        displayname: null,
                        description: null,
                        price: 0,
                        options: [],
                        value: null,
                        factor: null
                    }
                    this.errors.clear()
                    this.errorMsg = ''
                    this.$nextTick(() => {
                        this.$validator.reset()
                    })
                    this.isEditing = false
                    this.inputIndex = null
                }
                return isValid
            });
        },
        saveForm(){

            if(!this.login && this.labelAssignment){
                let isNameAssigned  = this.form.find((item) => item.name == 'name')
                let isEmailAssigned = this.form.find((item) => item.name == 'email')
                let isPhoneAssigned = this.form.find((item) => item.name == 'phone')

                if(isNameAssigned && isEmailAssigned && isPhoneAssigned)
                    this.$emit('on-submit', Object.assign([], this.form))
                else
                    this.errorMsg = `Please assign the ${!isNameAssigned ? 'name,': ''} ${!isEmailAssigned ? 'email,': ''} ${!isPhoneAssigned ? 'phone,': ''} field(s).`
            }
            else{
                this.$emit('on-submit', Object.assign([], this.form))
            }
        },
        handleInputConfirm () {
            let inputValue = this.model.input
            
            
            if (inputValue) {
                if (this.model.fieldtype != 'number' && inputValue.includes("-")) {
                    let parts = inputValue.split('-')
                    this.model.options.push({
                        name: parts[0],
                        price: parts[1] ? parseInt(parts[1]) : 0
                    })
                    this.model.input = ''
                }
                else if(this.model.fieldtype == 'number' && !isNaN(inputValue)){
                    this.model.options.push(inputValue)
                    this.model.input = ''
                }
                else if(this.model.fieldtype == 'number' && isNaN(inputValue)){
                    this.errorMsg = 'Please input a valid number'
                }
                else{
                    this.errorMsg = 'Please use a format like: name-price'
                }
            }
        },
        handleClose (val) {
            this.model.options.splice(this.model.options.indexOf(val), 1)
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        }
    }
}
</script>

<style lang="scss" scoped>

.cf-wrapper{
    position: relative;
    height: 90vh;

    .cf-creator{
        position: absolute;
        bottom: 0;

        margin-top: 15px;
        padding: 10px;
        box-shadow: 0px -10px 10px #eeeded;
    }
}

.cf-container{
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;

    .cf-input{
        margin: 5px;
        padding: 5px 10px;
        padding-left: 0px;
        margin-bottom: 15px;
        border: solid 1px #eeeded;
        box-shadow: 0px 2px 3px #eee;
        display: flex;
        align-items: center;
        justify-content: start;

        .cf-control-handle{
            padding: 5px 10px;
            line-height: 50px;
            text-align: center;
            vertical-align: middle;
            cursor: move;
            flex: 0.5;
        }

        .cf-input-control{
            flex: 6;
        }

        .cf-input-labels{
            flex: 2.5;
            text-align: center;
            display: flex;
            justify-content: center;

            label{
                color: #555;
                margin: 0px 2px;
                padding: 2px 4px;
                color: #bdc3c7;
                border-color: #bdc3c7;
                cursor: pointer;
                transition: all ease-in-out 0.2s;

                &:hover{
                    color: #7f8c8d;
                    border-color: #7f8c8d;
                }

                &.selected{
                    color: #ffffff;
                    background-color: #16a085;
                    border-color: #fff;
                    box-shadow: 0px 0px 0px 1px#16a085;
                }

                &.disabled{
                    color: #bdc3c7;
                    border-color: #bdc3c7;
                    cursor: not-allowed !important;
                }
            }
        }

        .cf-input-options{
            flex: 2.5;
            text-align: right;

            button{
                margin-right: 5px;
            }
        }
    }
}

/* width */
.cf-container::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.cf-container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px transparent; 
    border-radius: 3px;
}

/* Handle */
.cf-container::-webkit-scrollbar-thumb {
    background: #eee; 
    border-radius: 5px;
}

/* Handle on hover */
.cf-container::-webkit-scrollbar-thumb:hover {
    background: #aaa; 
}

.cf-creator,
.cf-container {
    .form-group label{
        margin-bottom: 0px;
        margin-left: 10px;
    }

    .input-new-tag{
        padding: 10px;
    }
}

.cf-creator .form-control-sm,
.cf-container .form-control-sm {
    height: calc(1.8125rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
}
.cf-creator {
    .form-control.input-new-tag{
        width: 250px!important;
        text-align: center;
        display: inline-block;
    }
}
</style>
